<div class="perfil-steps" [class.perfil-steps--open]="abierto">
  <button type="button" class="perfil-steps__toggle" id="btn-perfil-steps-progreso" [attr.aria-expanded]="abierto"
    aria-controls="perfil-steps-panel" (click)="toggle()">
    <span class="perfil-steps__toggle-label">{{ copy.stepsStrip.progresoToggle }}</span>
    <span class="perfil-steps__chevron" [class.perfil-steps__chevron--open]="abierto" aria-hidden="true"></span>
  </button>

  <div id="perfil-steps-panel" class="perfil-steps__panel" [class.perfil-steps__panel--open]="abierto">
    <div class="perfil-steps__summary">
      <app-perfil-progress-general [titulo]="copy.hub.title" [progreso]="progresoGlobal"
        [seccionesCompletas]="seccionesCompletas" [totalSecciones]="items.length"></app-perfil-progress-general>
    </div>

    <nav class="perfil-steps-strip" aria-label="Progreso de secciones del perfil">
      @for (paso of items; track paso.id) {
      <div class="perfil-steps-strip__step" [class.perfil-steps-strip__step--active]="isActiva(paso)"
        [class.perfil-steps-strip__step--complete]="isCompleta(paso)"
        [class.perfil-steps-strip__step--interactive]="isInteractive(paso)"
        [attr.aria-current]="isActiva(paso) ? 'step' : null"
        [attr.role]="isInteractive(paso) ? 'button' : null"
        [attr.tabindex]="isInteractive(paso) ? 0 : null"
        (click)="onStepClick(paso)" (keydown.enter)="onStepKeydown($event, paso)">
        <div class="perfil-steps-strip__icon" [class.perfil-steps-strip__icon--active]="isActiva(paso)"
          aria-hidden="true">
          <img class="perfil-steps-strip__img" [src]="iconSrc(paso.icon, isActiva(paso))" alt="" width="60" height="60" />
        </div>

        <div class="perfil-steps-strip__content">
          <div class="perfil-steps-strip__head">
            <div class="perfil-steps-strip__titles">
              <h2 class="perfil-steps-strip__title">{{ paso.titulo }}</h2>
              <p class="perfil-steps-strip__pct">{{ progresoLabel(paso.progreso) }}</p>
            </div>
            @if (isInteractive(paso)) {
            <span class="perfil-steps-strip__continuar">
              {{ accionLabel(paso) }} &gt;
            </span>
            }
          </div>

          <app-perfil-progress-section [progreso]="paso.progreso" [checkpoints]="paso.checkpoints"
            [highlightCurrent]="isActiva(paso)" [clickable]="canJumpSteps(paso)"
            (markerClick)="onMarkerClick(paso, $event)"></app-perfil-progress-section>
        </div>
      </div>
      }
    </nav>
  </div>

  <div class="perfil-steps__intro">
    <p class="perfil-steps__intro-title">{{ introTitle }}</p>
    <p class="perfil-steps__intro-subtitle">{{ introSubtitle }}</p>
  </div>
</div>
